import React, { FC } from "react";

import { Column, ExampleContainer, IconButton, ImageExample, ImageLabel, TitleExample } from "./styled";

import { ToolsHintBlockType } from "./types";

export const ToolsHintBlock: FC<ToolsHintBlockType & { className?: string }> = ({ title, hints, className }) => (
  <>
    <TitleExample>{title}</TitleExample>
    <ExampleContainer className={className}>
      {hints.map((hint, index) =>
        "icon" in hint ? (
          <IconButton key={index} kind={hint.icon} margin={"4.5rem"} disabled />
        ) : (
          <Column key={index}>
            <ImageExample img={hint.img} />
            <ImageLabel>{hint.label}</ImageLabel>
          </Column>
        ),
      )}
    </ExampleContainer>
  </>
);
